import {createRules} from "../../../common/validations/validations"


export const JOURNEY_SECS_BEFORE_APPOINTMENT = 15 * 60 // 15 minutes in secs
export const JOURNEY_SECS_RETOUR_DELAY = 3600 // 1 hour in secs
export const FIVE_MINUTES = 5 * 60 * 1000 // 5 minutes in ms

export enum ViewType {
  DAY = 'Day',
  DAYS = 'Days',
  WEEK = 'Week',
  WORKWEEK = 'WorkWeek',
  RESOURCE = 'Resources',
}

export enum ViewDay {
  DAY = 1,
  DAYS = 5,
  WEEK = 7,
  WORKWEEK = 5,
  RESOURCE = 1,
}

export enum ActionMode {
  CREATE = 1,
  MODIFY = 2,
  REMOVE = 3,
  REVOKE = 4,
  PRINT = 5,
}

export interface CalendarView {
  viewType: ViewType,
  viewDays: ViewDay,
}

export interface CalendarEventModel {
  // { id: 1, start: "2015-01-01T00:00:00", end: "2015-01-01T15:00:00", text: "Event 1", resource: "R1" }
  id: number
  start: string
  end: string
  text: string
  resourceId: string
}

export interface CalendarResourceModel {
  // { id: "R1", name: "Resource 1" }
  id: string
  name: string
}

// -----------------------------------------------------------------------------
// Checks

// -----------------------------------------------------------------------------
// Rules
export enum RuleField {
  CONTACT = 'contactId',
  DEPARTURE_ADDRESS = 'departureAddressId',
  ARRIVAL_ADDRESS = 'arrivalAddressId',
  VEHICLE = 'vehicleId',
  PERIOD = 'periodId',
  DESCRIPTION = 'description',
  RIDE_COMMENTS = 'rideComments',
}

export const CALENDAR_RULES = createRules<RuleField>([
  {
    field: RuleField.RIDE_COMMENTS,
    lengthRule: {
      min: 3, max: 100,
      message: '3-100 Zeichen erforderlich.',
    },
    requireRule: {
      required: true,
    },
    genericMessage: '3-100 Zeichen erforderlich.',
  },
])
